import { Link, useLocation } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../content';
import { Wordmark } from './Wordmark';

export function Footer() {
  const { pathname } = useLocation();
  const onLanding = pathname === '/';
  const hashLink = (id: string) => (onLanding ? `#${id}` : `/#${id}`);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <Link className="wordmark" to="/" aria-label="Cranio — home">
              <Wordmark />
            </Link>
            <p
              style={{
                color: 'var(--fg-3)',
                fontSize: 13.5,
                lineHeight: 1.6,
                marginTop: 18,
                maxWidth: 280,
              }}
            >
              A head-study studio for figure drawing and lighting practice. Made for iPhone, iPad
              &amp; Android.
            </p>
          </div>
          <div>
            <h4>Product</h4>
            <ul>
              <li><a href={hashLink('features')}>The studio</a></li>
              <li><a href={hashLink('models')}>Models</a></li>
              <li><a href={hashLink('materials')}>Finishes</a></li>
              <li><a href={hashLink('pricing')}>Pricing</a></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href={`mailto:${SUPPORT_EMAIL}`}>Email us</a></li>
              <li><a href={hashLink('download')}>Download</a></li>
            </ul>
          </div>
          <div>
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/terms">Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2025 Cranio Studio</span>
          <span>Designed in the dark · Made for makers</span>
        </div>
      </div>
    </footer>
  );
}
